/**
 * @generated SignedSource<<4741a595542c13a417a576e19cae90b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountid",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      }
    ],
    "concreteType": "AppIntegrationsForAccountsConnection",
    "kind": "LinkedField",
    "name": "getappintegrationsforaccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AppIntegrationsForAccount",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appIntegrationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appLogo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountDelegatedAuthsId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appData",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsIntegrationsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsIntegrationsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2f299cd1a6d57aff3b16b56aa0fa9489",
    "id": null,
    "metadata": {},
    "name": "SettingsIntegrationsQuery",
    "operationKind": "query",
    "text": "query SettingsIntegrationsQuery(\n  $accountId: UUID\n  $first: Int\n) {\n  getappintegrationsforaccount(accountid: $accountId, first: $first) {\n    totalCount\n    nodes {\n      appIntegrationId\n      appName\n      appDescription\n      appLogo\n      active\n      accountDelegatedAuthsId\n      appData\n    }\n  }\n}\n"
  }
};
})();

node.hash = "206cdff28f469ae7d7a816c800331996";

module.exports = node;
